import React from 'react';
import ResultValue from '../../Simple/ResultValue';

import { formatStringAsCurrency } from '../../../Utils/stringUtils';

export default function OtherPPSAmounts(props) {
    return (<>
        <h4>Other PPS Amounts</h4>
        <div className="row">
            <div className="col-md">
                <ResultValue label="HAC Adj." value={formatStringAsCurrency(props.result.hacAdj)} />
                <ResultValue label="Low Volume Adj." value={formatStringAsCurrency(props.result.lowVolume)} />
                <ResultValue label="Pass Through" value={formatStringAsCurrency(props.result.passThru)} />
                <ResultValue label="New Technology" value={formatStringAsCurrency(props.result.newTech)} />
            </div>
            <div className="col-md">
                <ResultValue label="Uncompensated Care" value={formatStringAsCurrency(props.result.ucp)} />
                <ResultValue label="Readmission Adj." value={formatStringAsCurrency(props.result.readmissionAdj)} />
                <ResultValue label="VBP Adj." value={formatStringAsCurrency(props.result.vbpAdj)} />
                <ResultValue label="Standard Acquisition Charge" value={formatStringAsCurrency(props.result.standardOrganAcquisitionCharge)} />
            </div>
        </div>
    </>);
}